import {
    BsSortDown,
    BsSortUp
} from "react-icons/bs";
import {
    OnestBoldSmall,
    OnestNormalDefault,
    OnestNormalMed,
    OnestNormalSmall,
    OnestSemiBoldBig,
    OnestSemiBoldSmall,
} from "../../components/styled/TextComponents";
import { PageTitle } from "../../components/text/PageTitle";
import {
    color_blue_light,
    color_grey_dark,
    color_grey_light,
    color_grey_ultra_light,
    color_red_default,
    color_transparent,
    color_white,
} from "../../constants/colors";
import PersonalDefaultPage from "./PersonalDefaultPage";

import axios from "axios";
import moment from "moment-timezone";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalQuestion from "../../components/blocks/ModalQuestion";
import ModalSimple from "../../components/blocks/ModalSimple";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { LoadingContainer } from "../../components/containers/LoadingContainer";
import { Button } from "../../components/controls/Button/Button";
import DeleteIcon from "../../components/icons/DeleteIcon";
import IconlyCurvedBoldAddUser from "../../components/icons/IconlyCurvedBoldAddUser";
import IconlyCurvedBoldSwap from "../../components/icons/IconlyCurvedBoldSwap";
import Config from "../../Config";
import { englishLevels } from "../../constants/levels";
import studentColorList from "../../constants/studentColorList";
import weekDayToNameMap from "../../constants/weekDayToNameMap";
import { updateAllStudents } from "../../store/StudentsJournalSlice";
import { setUser } from "../../store/UserSlice";
import generateLessonsSchedule from "../../utilities/generateLessonsSchedule";
import { isDesktop } from "../../utilities/getDeviceType";
import { useWindowDimensions } from "../../utils";
import { useI18n } from "../../i18n/I18nProvider";

const styles = {
  journalHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    gap: 0,
  },
  journalHeaderButton: {
    height: 45,
    width: 45,
    borderRadius: "50%",
    backgroundColor: color_white,
    boxSizing: "border-box",
    color: color_red_default,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 25,
    flexShrink: 0,
    cursor: "pointer",
  },
  journalSearch: {
    width: 260,
    height: 45,
    backgroundColor: color_white,
    borderRadius: 10,
    borderColor: color_transparent,
    paddingLeft: 40,
    boxSizing: "border-box",
    color: color_grey_dark,
  },
};

const JOURNAL_DESKTOP_COLUMNS = {
  name: 240,
  schedule: 240,
  paid: 240,
  program: 225,
  actions: 95,
};

const JOURNAL_TABLET_COLUMNS = {
  name: 160,
  schedule: 170,
  paid: 95,
  program: 100,
  actions: 95,
};

const getJournalColumns = (screenWidth) =>
  screenWidth >= 1280 ? JOURNAL_DESKTOP_COLUMNS : JOURNAL_TABLET_COLUMNS;

const SEARCH_ICON_DATA_URI =
  "url(\"data:image/svg+xml;utf8,<svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.875 11.875C9.63642 11.875 11.875 9.63642 11.875 6.875C11.875 4.11358 9.63642 1.875 6.875 1.875C4.11358 1.875 1.875 4.11358 1.875 6.875C1.875 9.63642 4.11358 11.875 6.875 11.875Z' stroke='%23B1B1B1' stroke-linecap='round' stroke-linejoin='round'/><path d='M13.125 13.125L10.4062 10.4062' stroke='%23B1B1B1' stroke-linecap='round' stroke-linejoin='round'/></svg>\")";

const JournalSearch = ({ searchWord, setSearchWord }) => {
  const { t } = useI18n();
  const { width: screenWidth } = useWindowDimensions();
  const isMobile = screenWidth < 780;
  const isTabletPortrait = screenWidth >= 700 && screenWidth <= 900;
  return (
    <div
      style={{
        ...((isTabletPortrait || isMobile) ? { flexGrow: 1, minWidth: 0 } : {}),
        position: "relative",
      }}
    >
      <input
        type={"text"}
        style={{
          ...styles.journalSearch,
          fontFamily: "Onest",
          fontSize: 16,
          width: (isTabletPortrait || isMobile) ? "100%" : 260,
          backgroundImage: SEARCH_ICON_DATA_URI,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "15px center",
        }}
        placeholder={t("Найти ученика")}
        value={searchWord}
        onChange={(e) => setSearchWord(e.target.value)}
      />
    </div>
  );
};
const JournalHeader = ({
  searchWord,
  setSearchWord,
  sorting,
  setNextSorting,
}) => {
  const { t } = useI18n();
  const { width: screenWidth } = useWindowDimensions();
  const isMobile = screenWidth < 780;
  const navigate = useNavigate();
  const studentsJournal = useSelector((state) => state.studentsJournal);
  const sortingIcon = () => {
    switch (sorting) {
      case "ASC":
        return <BsSortUp />;
      case "DESC":
        return <BsSortDown />;
      default:
        return <IconlyCurvedBoldSwap />;
    }
  };
  console.log("studentsJournal: ", studentsJournal.length);
  return (
    <>
      {screenWidth < 780 && <PageTitle title={t("Журнал учеников")} />}
      {screenWidth < 780 && <div style={{ height: 16 }} />}
      <div style={{ ...styles.journalHeaderContainer, justifyContent: isMobile ? "flex-start" : "space-between" }}>
        {screenWidth >= 780 && <PageTitle title={t("Журнал учеников")} />}
        {screenWidth >= 780 && <div style={{ flexGrow: 1 }} />}
        <JournalSearch searchWord={searchWord} setSearchWord={setSearchWord} />
        <div style={{ display: "flex", flexDirection: "row", gap: 5, marginLeft: isMobile ? 5 : 10, flexShrink: 0 }}>
          <div
            style={{ ...styles.journalHeaderButton, cursor: "pointer" }}
            onClick={() => setNextSorting()}
          >
            {sortingIcon()}
          </div>
          {studentsJournal.length < 31 ? (
            <div
              onClick={() => navigate("/service/students/new")}
              style={{ ...styles.journalHeaderButton }}
            >
              <IconlyCurvedBoldAddUser />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

const JournalTableHeader = ({ screenWidth }) => {
  const { t } = useI18n();
  const columnsMap = getJournalColumns(screenWidth);
  const columns = [
    {
      name: t("Имя"),
      flex: columnsMap.name,
    },
    {
      name: t("Расписание занятий"),
      flex: columnsMap.schedule,
    },
    {
      name: t("Оплаченные занятия"),
      flex: columnsMap.paid,
    },
    {
      name: t("Программа"),
      flex: columnsMap.program,
    },
    {
      name: t("Управление"),
      flex: columnsMap.actions,
    },
  ];
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
      }}
    >
      {columns.map((el) => (
        <div
          style={{
            color: color_grey_dark,
            flex: `${el.flex} ${el.flex} 0`,
            minWidth: 0,
          }}
        >
          <OnestSemiBoldSmall>{el.name}</OnestSemiBoldSmall>
        </div>
      ))}
    </div>
  );
};

const JorunalStudentPreviewData = ({
  studentName,
  studentPhoto,
  studentId,
  columns,
}) => {
  const studentColorScheme = studentColorList[studentId % 10];
  const nameParts = (studentName || "").trim().split(/\s+/).filter(Boolean);
  const firstLine = nameParts[0] || "";
  const secondLine = nameParts.slice(1).join(" ");

  return (
    <div
      style={{
        flex: `${columns.name} ${columns.name} 0`,
        minWidth: 0,
        display: "flex",
        flexDirection: "row",
        gap: 15,
      }}
    >
      <div
        style={{
          width: 50,
          height: 50,
          lineHeight: 4,
          borderRadius: "50%",
          color: studentColorScheme.color,
          textAlign: "center",
          background: studentPhoto
            ? `url(${Config.CLOUD_ADDR}/${studentPhoto})`
            : studentColorScheme.backgroundColor,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {!studentPhoto && (
          <OnestNormalSmall style={{ marginTop: -4 }}>
            {studentName
              .split(" ")
              .map((el) => Array.from(el)[0])
              .join("")}
          </OnestNormalSmall>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          justifyContent: "center",
          minWidth: 0,
            overflow: "hidden",
        }}
      >
          <OnestNormalMed style={{ lineHeight: "20px" }}>{firstLine}</OnestNormalMed>
          <OnestNormalMed
            style={{
              lineHeight: "20px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {secondLine}
          </OnestNormalMed>
      </div>
    </div>
  );
};

const JournalStudentLessons = ({ studentLessons, columns = JOURNAL_TABLET_COLUMNS }) => {
  const normalizeLessonTime = (timeValue) =>
    (timeValue || "")
      .replace(/\s*-\s*\d+\s*занят(ие|ия|ий)\s*$/i, "")
      .trim();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 5,
        flex: `${columns.schedule} ${columns.schedule} 0`,
        minWidth: 0,
      }}
    >
      {studentLessons.map((el) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
          }}
        >
          <OnestBoldSmall>{el.weekDayShort}</OnestBoldSmall>
          <OnestNormalSmall>{normalizeLessonTime(el.time)}</OnestNormalSmall>
        </div>
      ))}
    </div>
  );
};

const JournalTableRow = ({ studentData, onClick, deleteStudentHandler }) => {
  const { width: screenWidth } = useWindowDimensions();
  const columns = getJournalColumns(screenWidth);
  const [isHover, setIsHover] = useState(false);
  const [isTrashHover, setIsTrashHover] = useState(false);

  return (
    <div
      key={studentData.studentId}
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "min-content",
        minHeight: 90,
        paddingTop: 15,
        borderTop: `1px solid ${color_grey_light}`,
        cursor: "pointer",
        backgroundColor: isHover ? color_grey_ultra_light : color_transparent,
        alignItems: "center",
        overflow: "hidden",
        // justifyContent: "space-around"
      }}
      onClick={() => onClick()}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <JorunalStudentPreviewData
        studentName={studentData.name}
        studentPhoto={studentData.image}
        studentId={studentData.studentId}
        columns={columns}
      />
      <JournalStudentLessons
        studentLessons={studentData.lessonsSchedule}
        columns={columns}
      />
      <div style={{ flex: `${columns.paid} ${columns.paid} 0`, minWidth: 0 }}>
        <OnestNormalDefault>
          {parseInt(
            studentData.studentId !== -1 && studentData.lessonPrice !== 0
              ? studentData.balance / studentData.lessonPrice
              : 0,
          )}
        </OnestNormalDefault>
      </div>
      <div style={{ flex: `${columns.program} ${columns.program} 0`, minWidth: 0 }}>
        <OnestNormalDefault>
          {englishLevels[studentData.englishLevel]}
        </OnestNormalDefault>
      </div>
      <div style={{ flex: `${columns.actions} ${columns.actions} 0`, minWidth: 0 }}>
        <div
          style={{
            ...styles.journalHeaderButton,
            fontSize: 16,
            backgroundColor: color_grey_ultra_light,
            width: 32,
            height: 32,
            cursor: "pointer",
            border: isTrashHover ? `1px solid ${color_grey_light}` : null,
          }}
          onMouseEnter={() => setIsTrashHover(true)}
          onMouseLeave={() => setIsTrashHover(false)}
          onClick={(e) => {
            e.stopPropagation();
            deleteStudentHandler();
          }}
        >
          <DeleteIcon />
        </div>
      </div>
    </div>
  );
};

const JournalTableTile = ({ studentData, onClick, deleteStudentHandler }) => {
  const { t } = useI18n();
  const { width: screenWidth } = useWindowDimensions();

  const [isHover, setIsHover] = useState(false);
  const [isTrashHover, setIsTrashHover] = useState(false);

  const tableRowStyle = {
    //padding: 10,
    paddingTop: 15,
    paddingBottom: 15,
    display: "flex",
    flexDirection: "row",
    gap: 15,
    width: "100%",
    boxSizing: "border-box",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${color_grey_light}`,
  };

  return (
    <div
      key={studentData.studentId}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "min-content",
        width: "100%",
        minHeight: 90,
        marginTop: 15,
        cursor: "pointer",
        backgroundColor: isHover ? color_grey_ultra_light : color_transparent,
        alignItems: "center",
        boxSizing: "border-box",
        // justifyContent: "space-around"
      }}
      onClick={() => onClick()}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 15,
          width: "100%",
          boxSizing: "border-box",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 15,
          borderRadius: 15,
          backgroundColor: isHover ? color_blue_light : color_white,
          BsBorderWidth: 0,
        }}
      >
        <div
          style={{
            width: 50,
            height: 50,
            lineHeight: 4,
            borderRadius: "50%",
            color: studentColorList[studentData.studentId % 10].color,
            textAlign: "center",
            background: studentData.image
              ? `url(${Config.CLOUD_ADDR}/${studentData.image})`
              : studentColorList[studentData.studentId % 10].backgroundColor,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {!studentData.image && (
            <OnestNormalSmall style={{ marginTop: -4 }}>
              {studentData.name
                .split(" ")
                .map((el) => Array.from(el)[0])
                .join("")}
            </OnestNormalSmall>
          )}
        </div>
        <OnestNormalMed>{studentData.name}</OnestNormalMed>

        <div
          style={{
            ...styles.journalHeaderButton,
            fontSize: 16,
            backgroundColor: color_grey_ultra_light,
            width: 32,
            height: 32,
            cursor: "pointer",
            border: isTrashHover ? `1px solid ${color_grey_light}` : null,
          }}
          onMouseEnter={() => setIsTrashHover(true)}
          onMouseLeave={() => setIsTrashHover(false)}
          onClick={(e) => {
            e.stopPropagation();
            deleteStudentHandler();
          }}
        >
          <DeleteIcon />
        </div>
      </div>
      <div
        style={{
          marginTop: 5,
          display: "flex",
          flexDirection: "column",
          //gap: 15,
          width: "100%",
          boxSizing: "border-box",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: 15,
          borderRadius: 15,
          backgroundColor: isHover ? color_blue_light : color_white,
          BsBorderWidth: 0,
        }}
      >
        <div style={tableRowStyle}>
          <OnestNormalDefault>{t("Расписание")}</OnestNormalDefault>
          <div style={{ marginLeft: "auto" }}>
            <JournalStudentLessons
              studentLessons={studentData.lessonsSchedule}
            />
          </div>
        </div>
        <div style={tableRowStyle}>
          <OnestNormalDefault>{t("Оплачено")}</OnestNormalDefault>
          <OnestNormalDefault>
            {parseInt(
              studentData.studentId !== -1 && studentData.lessonPrice !== 0
                ? studentData.balance / studentData.lessonPrice
                : 0,
            )}
          </OnestNormalDefault>
        </div>
        <div style={{ ...tableRowStyle, borderBottom: "0px" }}>
          <OnestNormalDefault>{t("Уровень")}</OnestNormalDefault>
          <OnestNormalDefault>
            {englishLevels[studentData.englishLevel]}
          </OnestNormalDefault>
        </div>
      </div>
    </div>
  );
};

export function weekDayToFullWeekName(weekDay) {
  if (Object.keys(weekDayToNameMap).includes(weekDay.toString()))
    return weekDayToNameMap[weekDay];
  return { full: "UNKNOWN", short: "UN" };
}

export function addZeroToTime(timeVal) {
  return parseInt(timeVal) < 10 ? `0${timeVal}` : `${timeVal}`;
}

const JournalTable = ({ searchWord, sorting }) => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();

  const navigate = useNavigate();
  const studentsJournal = useSelector((state) => state.studentsJournal);
  const dispatch = useDispatch();
  const [isModalSimpleOpen, setIsModalSimpleOpen] = useState(false);
  const handleCloseModalSimple = useCallback(() => {
    setIsModalSimpleOpen(false);
  }, []);
  const [studentDataToDelete, setStudentDataToDelete] = useState(null);
  const [ModalSimpleH, setModalSimpleH] = useState(t("Ученик удалён"));
  const [ModalSimpleP, setModalSimpleP] = useState("");
  const [ModalSimpleType, setModalSimpleType] = useState("success");
  const [ModalSimpleButtonText, setModalSimpleButtonText] = useState(t("Закрыть"));
  const [isModalQuestionOpen, setIsModalQuestionOpen] = useState(false);
  const handleCloseModalQuestion = useCallback(
    (isYes) => {
      setIsModalQuestionOpen(false);
      if (isYes) {
        // Удалить ученика
        axios
          .delete(
            Config.BACKEND_ADDR + `/students/${studentDataToDelete.studentId}`,
          )
          .then(() => {
            dispatch(
              updateAllStudents(
                studentsJournal.filter(
                  (el) => el.studentId !== studentDataToDelete.studentId,
                ),
              ),
            );
            setModalSimpleType("success");
            setModalSimpleH(t("Ученик удалён"));
            setModalSimpleP("");
            setModalSimpleButtonText(t("Закрыть"));
            setIsModalSimpleOpen(true);
            setStudentDataToDelete(null);
          })
          .catch((error) => {
            console.error("Ошибка при удалении ученика:", error);
            setModalSimpleType("error");
            setModalSimpleH(t("Ошибка"));
            setModalSimpleP(t("Не удалось удалить ученика. Попробуйте позже."));
            setModalSimpleButtonText(t("Закрыть"));
            setIsModalSimpleOpen(true);
          });
      }
    },
    [dispatch, studentDataToDelete, studentsJournal, t],
  );

  const sortedJournal = () => {
    switch (sorting) {
      case "ASC":
        return [...studentsJournal].sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
        );
      case "DESC":
        return [...studentsJournal].sort((a, b) =>
          b.name > a.name ? 1 : a.name > b.name ? -1 : 0,
        );
      default:
        return studentsJournal;
    }
  };

  function deleteStudentHandler(studentData) {
    setStudentDataToDelete(studentData);
    setIsModalQuestionOpen(true);
  }

  if (screenWidth > 700) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: color_white,
          borderRadius: 20,
          padding: 20,
          marginTop: 20,
          width: "100%",
          boxSizing: "border-box",
          justifyContent: "space-around",
          overflowX: "auto",
        }}
      >
        <ModalSimple
          type={ModalSimpleType}
          h2={ModalSimpleH}
          p={ModalSimpleP}
          isOpen={isModalSimpleOpen}
          onClose={handleCloseModalSimple}
          buttonText={ModalSimpleButtonText}
        />
        <ModalQuestion
          type={"question"}
          h2={t("Удалить ученика?")}
          p={t("Отменить действие будет невозможно")}
          isOpen={isModalQuestionOpen && studentDataToDelete !== null}
          onClose={handleCloseModalQuestion}
          yesText={t("Да, удалить")}
          noText={t("Нет, не удалять")}
          isButtonRevers={false}
        />

        <div style={{ minWidth: 680 }}>
          <JournalTableHeader screenWidth={screenWidth} />
          <div style={{ height: 24 }} />
          {sortedJournal()
            .filter((el) =>
              el.name.toLowerCase().includes(searchWord.toLowerCase()),
            )
            .map((el) => (
              <JournalTableRow
                studentData={el}
                onClick={() => {
                  navigate(`/service/students/${el.studentId}`);
                }}
                deleteStudentHandler={() => deleteStudentHandler(el)}
              />
            ))}
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 20,
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {sortedJournal()
          .filter((el) =>
            el.name.toLowerCase().includes(searchWord.toLowerCase()),
          )
          .map((el) => (
            <JournalTableTile
              studentData={el}
              onClick={() => {
                navigate(`/service/students/${el.studentId}`);
              }}
              deleteStudentHandler={() => deleteStudentHandler(el)}
            />
          ))}
      </div>
    );
  }
};

const JournalPage = () => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const mobileJournalWidth = Math.min(
    Math.max(300, Math.min(330, screenWidth - 45)),
    screenWidth - 24,
  );
  const user = useSelector((state) => state.user);
  const studentsJournal = useSelector((state) => state.studentsJournal);
  const timeZone =
    user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone; // Замените на ваш часовой пояс по умолчанию
  const navigate = useNavigate();
  const gDate = moment(); // Текущее время
  console.warn("gDate SchedulePage", gDate.format());
  const formattedDate = gDate.tz(timeZone); // Преобразование даты в нужный часовой пояс

  const [searchWord, setSearchWord] = useState("");
  const [journalSorting, setJournalSorting] = useState(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      console.log("navbaruser ", user);
      if (!user || Object.keys(user).length === 0) {
        try {
          const data = await get_user();
          dispatch(setUser(data));
        } catch (error) {
          console.error("Error fetching user data:", error);
          // Обработка ошибки, например, перенаправление на страницу входа
          //navigate('/auth/login');
        }
      }
    })();
  }, [dispatch, user]);

  useEffect(() => {
    getStudents().then((res) => {
      dispatch(updateAllStudents(res));
      setIsLoading(false);
    });
  }, []);

  async function getStudents() {
    let lessonsData = (await axios.get(Config.BACKEND_ADDR + `/lessons/`)).data;
    console.log("lessonsData", lessonsData);

    let studentsData = (
      await axios.get(Config.BACKEND_ADDR + `/students/`)
    ).data.map((studentData) => {
      const lessonsScheduleResult = generateLessonsSchedule(
        lessonsData,
        studentData,
        timeZone,
      );

      return {
        studentId: studentData.id,
        lessonPrice: studentData.lesson_cost,
        balance: studentData.balance,
        age: studentData.age,
        image: studentData.image,
        payedLessons: parseInt(studentData.balance / studentData.lesson_cost),
        name: studentData.name,
        englishLevel: studentData.english_skill,
        additionalInfo: studentData.info,
        lessonsSchedule: lessonsScheduleResult,
        lessonsProgram: [],
      };
    });
    console.log("studentdsData", studentsData);
    return studentsData;
  }

  function setNextSorting() {
    let sortingMethods = [null, "ASC", "DESC"];
    let current = sortingMethods.indexOf(journalSorting);
    let nextIndex =
      current + 1 <= sortingMethods.length - 1
        ? current + 1
        : current + 1 - sortingMethods.length;
    setJournalSorting(sortingMethods[nextIndex]);
  }

  useEffect(() => {
    let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod"; // /api
    axios
      .get(backendAddr)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === "not_paid") {
            navigate("/billing/");
          }
        }
      })
      .catch((err) => {
        console.warn("Ошибка проверки подписки в БД! ", err);
      });
  }, [navigate]);

  return (
    <>
      <PersonalDefaultPage>
        <LoadingContainer isLoading={isLoading}>
          {studentsJournal.length === 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: screenHeight - 200,
                width:
                  screenWidth >= 1280 && isDesktop()
                    ? "min(1100px, calc(100vw - 340px))"
                    : screenWidth - 30,
              }}
            >
              <OnestSemiBoldBig>{t("Учеников пока нет")}</OnestSemiBoldBig>
              <OnestNormalDefault
                style={{
                  color: color_grey_dark,
                  marginTop: 10,
                  textAlign: "center",
                }}
              >
                {t("Добавьте ученика, чтобы начать вести журнал")}
              </OnestNormalDefault>
              <div style={{ height: 20 }} />

              <Button
                onClick={() => navigate("/service/students/new")}
                backgroundColor={color_red_default}
                height={40}
                width={225}
                fontFamily={"Onest"}
                style={{
                  borderColor: color_red_default,
                  textColor: color_white,
                }}
              >
                <OnestNormalDefault
                  color={color_white}
                  style={{
                    color: color_white,
                  }}
                >
                  {t("Добавить ученика")}
                </OnestNormalDefault>
              </Button>
            </div>
          ) : (
            <div
              style={{
                //padding: 20,
                width:
                  screenWidth >= 1280 && isDesktop()
                    ? "min(1100px, calc(100vw - 340px))"
                    : screenWidth > 700
                      ? screenWidth - 50
                      : mobileJournalWidth,
                margin:
                  screenWidth >= 1280 && isDesktop()
                    ? "0 auto"
                    : screenWidth <= 700
                      ? "0 auto"
                      : undefined,
              }}
            >
              <JournalHeader
                searchWord={searchWord}
                setSearchWord={(word) => setSearchWord(word)}
                sorting={journalSorting}
                setNextSorting={() => setNextSorting()}
              />
              <JournalTable searchWord={searchWord} sorting={journalSorting} />
            </div>
          )}
        </LoadingContainer>
      </PersonalDefaultPage>
    </>
  );
};

export default JournalPage;
